export const ErrorPing = () => {
  return (
    <span className="absolute -top-0.5 -right-2 animate-ping inline-block size-1.5 rounded-full bg-destructive opacity-75" />
  );
};
